<template>
  <div>
  
  
        
             
       <div style="margin-top:90px;">
       <h5 style="font-weight:bold;">My Commission</h5>
  		</div>
		
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="commission">
                  <el-table-column label="Value Date">
            		<template slot-scope="scope">
            			{{scope.row.date_str}}
            		</template>
               </el-table-column>
                 <el-table-column label="Title">
            		<template slot-scope="scope">
            			{{scope.row.title}}
            		</template>
               </el-table-column>
               
               
               <el-table-column label="Amount">
            		<template slot-scope="scope">
            			${{scope.row.amount}}
            		</template>
               </el-table-column>
            		
            		
     	
                
           
                 
                  
                 
            </el-table>

          </div>
        </div>
        
        
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {

      	this.initPage();
    },
    
     
    data () {
      return {
        coy:[],
        commission:[],
	    associate:{
        	user:{user_info:[]},
        },    	eid: this.$route.params.eid,
		account: {
          email: '',
        },
        modelValidations: {
          title: {
          },
          description: {
          },
          email: {
            required: true,
            email:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
      }
    },
    methods:{
      goToEntity(){
	  	   this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    getError(fieldName) {
        return this.errors.first(fieldName)
      },
      
      addCommission(row){
      	this.$router.push( '/add-commission/' + row.user.id);
      },
      viewCommission(row){
      	this.$router.push( '/view-commission/' + row.user.id);
      },
      
	    initPage(){
	    	let uri = this.$base_url+'/api/v1/entities/get/my_commission';
			 ApiService.get(uri).then(response => {
				this.commission = response.data.commission;
			})
	    },
	   
	  
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


